/* eslint-disable import/no-anonymous-default-export */
/**
 * TV 광고 캠페인 관리 설정
 */
import RefundBadge from "../components/RefundBadge";

function getStatusLabel(status) {
  switch (status) {
    case "waiting":
      return "대기중";
    case "processing":
      return "진행중";
    case "completed":
      return "완료";
    case "refunded":
      return "환불";
    default:
      return status || "-";
  }
}

function formatImpressions(n) {
  if (n == null) return "-";
  return `${Number(n).toLocaleString()}건`;
}

function formatAmount(n) {
  if (n == null) return "-";
  return `${Number(n).toLocaleString()}원`;
}

/** 영상제작: 1=제작 의뢰, 0=직접 업로드 */
function getTvAdProductionLabel(yn) {
  return yn === 1 ? "유" : "무";
}

/** 영상길이(초) → "15초", "30초" */
function getAdDurationLabel(sec) {
  if (sec == null) return "-";
  return `${sec}초`;
}

/** 할증/보너스 퍼센트 */
function getPercentLabel(n) {
  if (n == null || n === 0) return "-";
  return `${n}%`;
}

/** 성우 성별 */
function getVoiceGenderLabel(v) {
  if (!v) return "-";
  const map = { male: "남자", female: "여자", man: "남자", woman: "여자" };
  return map[v] || v;
}

/** 성우 연령 */
function getVoiceAgeLabel(v) {
  if (!v) return "-";
  const map = {
    child: "어린이",
    teen: "청소년",
    adult: "성인",
    middle: "중년",
    old: "노년",
  };
  return map[v] || v;
}

/** 매체사(상품 타입) 단일 값 → 라벨 */
function getMediaTypeLabel(type) {
  if (!type) return "-";
  switch (String(type).toUpperCase()) {
    case "LGUPLUS":
      return "IPTV 3사";
    case "SKB":
      return "SKB";
    default:
      return type;
  }
}

/** 알림톡용 상품명 반환 */
function getProductNameForNotification(type) {
  if (!type) return "TV 광고 캠페인";
  switch (String(type).toUpperCase()) {
    case "LGUPLUS":
      return "TV 광고 캠페인";
    case "SKB":
      return "SK브로드밴드 IPTV";
    default:
      return "TV 광고 캠페인";
  }
}

export default {
  id: "adTvAd",
  title: "TV 광고 캠페인",

  api: {
    list: {
      method: "GET",
      url: "/advertisement/admin/campaigns/by-type",
      params: { type: "tv_ad" },
    },
    count: {
      method: "GET",
      url: "/advertisement/admin/campaigns/by-type/count",
      params: { type: "tv_ad" },
    },
    submitted: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
    },
    paid: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
    },
    complete: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
    },
    refund: {
      method: "POST",
      url: "/advertisement/admin/campaigns/by-type/status",
      version: 2,
      type: "tv_ad",
    },
    delete: {
      method: "DELETE",
      url: "/advertisement/admin/campaigns/by-type",
    },
  },

  filters: {
    default: {
      keyword: "",
      productTypes: [],
      submitDate: "",
      status: "전체",
      submitted: "전체",
      paid: "전체",
      page: 1,
      limit: 50,
    },
    schema: [
      {
        name: "productTypes",
        label: "상품 타입",
        type: "checkbox-group",
        options: [
          { value: "LGUPLUS", label: "LGU+" },
          { value: "SKB", label: "SKB" },
        ],
      },
      {
        name: "keyword",
        label: "검색",
        type: "text",
        placeholder: "신청자, 상호명",
      },

      {
        name: "submitDate",
        label: "접수일",
        type: "date",
      },
      {
        name: "submitted",
        label: "접수여부",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "접수완료" },
          { value: "notComplete", label: "미접수" },
        ],
      },
      {
        name: "paid",
        label: "결제상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "complete", label: "결제완료" },
          { value: "notComplete", label: "미결제" },
          { value: "refund", label: "환불" },
        ],
      },
      {
        name: "status",
        label: "상태",
        type: "select",
        options: [
          { value: "전체", label: "전체" },
          { value: "waiting", label: "대기중" },
          { value: "processing", label: "진행중" },
          { value: "completed", label: "완료" },
        ],
      },
    ],
  },

  summary: {
    fields: [
      { key: "totalCount", label: "총 신청" },
      { key: "waitingCount", label: "대기중" },
      { key: "processingCount", label: "진행중" },
      { key: "completedCount", label: "완료" },
    ],
  },

  table: {
    keyField: "adTvAdId",
    columns: [
      {
        key: "adCampaignMetaId",
        label: "아이디",
        center: true,
      },
      {
        key: "createdAt",
        label: "캐랭접수시간",
        center: true,
        render: (row) => {
          if (!row.createdAt) return "";
          const [date, time] = row.createdAt.split(" ");
          return (
            <>
              <div>{date}</div>
              <div>{time?.slice(0, 8)}</div>
            </>
          );
        },
      },
      {
        key: "userName",
        label: "신청자(ID)\n접수일\n상태",
        center: true,
        render: (row) => (
          <>
            <div>
              <span className="user-name">
                {row.userName}
                {row.userId ? ` (${row.userId})` : ""}
              </span>
            </div>
            <div>{row.submitDate || "-"}</div>
            <div>
              <span className={`badge badge-${row.status}`}>
                {getStatusLabel(row.status)}
              </span>
            </div>
          </>
        ),
      },
      {
        key: "period",
        label: "시작일\n종료일\n송출기간",
        center: true,
        render: (row) => (
          <>
            <div>{row.startDate || "-"}</div>
            <div>{row.endDate || "-"}</div>
            <div>
              {row.progressMonths != null ? `${row.progressMonths}개월` : "-"}
            </div>
          </>
        ),
      },
      {
        key: "impressions",
        label: "기본 노출수\n보너스 노출수\n매체사\n총금액 (단가)",
        center: true,
        render: (row) => {
          const total =
            row.totalAmount != null ? row.totalAmount : row.campaignTotalAmount;
          const typeVal =
            row.type ??
            (Array.isArray(row.mediaPublisher) && row.mediaPublisher.length
              ? row.mediaPublisher[0]
              : null);
          const unitPrice =
            total && row.totalImpressions
              ? Math.round(total / row.totalImpressions)
              : 0;
          return (
            <>
              <div>{formatImpressions(row.defaultImpressions)}</div>
              <div>{formatImpressions(row.bonusImpressions)}</div>
              <div>{getMediaTypeLabel(typeVal)}</div>
              <div>
                {total != null
                  ? `${formatAmount(total)} (${formatAmount(unitPrice)})`
                  : "-"}
              </div>
            </>
          );
        },
      },
      {
        key: "productionCost",
        label: "영상제작비",
        center: true,
        render: (row) => {
          if (row.tvAdProductionYn === 1) {
            return row.tvAdProductionCost === 0
              ? "공통적용"
              : formatAmount(row.tvAdProductionCost);
          }
          return "-";
        },
      },
      {
        key: "place",
        label: "상호명 (업종)\n연락처\n주소\nQR용 URL",
        center: true,
        render: (row) => (
          <>
            <div>
              {row.placeName || "-"} {row.category ? `(${row.category})` : ""}
            </div>
            <div>{row.phoneNum || "-"}</div>
            <div>{row.address || "-"}</div>
            <div>
              {row.qrUrl ? (
                <a
                  href={row.qrUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={(e) => e.stopPropagation()}
                >
                  {row.qrUrl}
                </a>
              ) : (
                "-"
              )}
            </div>
          </>
        ),
      },
      {
        key: "targetRegions",
        label: "송출 지역",
        center: true,
        render: (row) => {
          const regions = row.targetRegions;
          if (!regions || !regions.length) return "-";
          return Array.isArray(regions) ? regions.join(", ") : String(regions);
        },
      },
      {
        key: "production",
        label: "영상제작 유무\n영상길이\n할증\n보너스",
        center: true,
        render: (row) => (
          <>
            <div>{getTvAdProductionLabel(row.tvAdProductionYn)}</div>
            <div>{getAdDurationLabel(row.adDuration)}</div>
            <div>{getPercentLabel(row.surcharge)}</div>
            <div>{getPercentLabel(row.bonus)}</div>
          </>
        ),
      },
      {
        key: "promo",
        label: "홍보문구\n마지막씬 강조 정보",
        center: true,
        render: (row) => {
          const info = row.tvAdProductionInfo;
          if (!info)
            return (
              <>
                <div>-</div>
                <div>-</div>
              </>
            );
          return (
            <>
              <div
                className="guideline-textbox"
                title={info.promo_message || "-"}
              >
                {info.promo_message || "-"}
              </div>
              <div>{info.final_scene_highlight || "-"}</div>
            </>
          );
        },
      },
      {
        key: "voice",
        label: "성우 성별\n성우 연령\n성우 분위기\n성우 멘트",
        center: true,
        render: (row) => {
          const noProduction = row.tvAdProductionYn !== 1;
          const info = row.tvAdProductionInfo;
          if (noProduction || !info)
            return <div>-</div>;
          return (
            <>
              <div>{getVoiceGenderLabel(info.ai_voice_gender)}</div>
              <div>
                {getVoiceAgeLabel(info.ai_voice_age) ||
                  info.ai_voice_age ||
                  "-"}
              </div>
              <div>{info.ai_voice_tone || "-"}</div>
              <div
                className="guideline-textbox"
                title={info.ai_voice_script || "-"}
              >
                {info.ai_voice_script || "-"}
              </div>
            </>
          );
        },
      },
      {
        key: "paymentType",
        label: "결제방법\n결제여부",
        center: true,
        render: (row) => (
          <>
            <div>
              {row.paymentType === "card"
                ? "카드"
                : row.paymentType === "v_bank"
                  ? "가상계좌"
                  : row.paymentType === "account"
                    ? "계좌이체"
                    : row.paymentType === "point"
                      ? "포인트 결제"
                      : row.paymentType
                        ? row.paymentType
                        : "-"}
            </div>
            <div>
              {row.isRefunded === 1 ? (
                <RefundBadge
                  refundedAmount={row.refundedAmount ?? 0}
                  remainingAmount={row.remainingAmount ?? 0}
                  refundDate={row.refundDate}
                />
              ) : (
                <span
                  className={`badge badge-${row.isPaid === 1 ? "결제완료" : "미결제"}`}
                >
                  {row.isPaid === 1 ? "결제완료" : "미결제"}
                </span>
              )}
            </div>
          </>
        ),
      },
      {
        key: "report",
        label: "리포트",
        center: true,
        render: (row) => (
          <button
            type="button"
            className="status-btn submitted"
            data-campaign-meta-id={row.adCampaignMetaId}
            data-place-name={row.placeName || ""}
          >
            리포트
          </button>
        ),
      },
      {
        key: "notification",
        label: "알림톡 발송",
        center: true,
        render: (row) => {
          const productName = getProductNameForNotification(row.type);
          return (
            <button
              type="button"
              className="notification-btn"
              data-campaign-meta-id={row.adCampaignMetaId}
              data-action="notification"
              data-user-id={row.userId}
              data-product-name={productName}
              data-submitted-at={row.createdAt || ""}
              data-purchase-amount={
                row.totalAmount ?? row.campaignTotalAmount ?? ""
              }
              onClick={(e) => e.stopPropagation()}
            >
              알림톡
            </button>
          );
        },
      },
      {
        key: "memo",
        label: "메모",
        center: true,
        render: (row) => (
          <button
            type="button"
            className={row.memo ? "memo-btn has-memo" : "memo-btn"}
            data-action="memo"
            data-campaign-meta-id={row.adCampaignMetaId}
            data-memo={row.memo || ""}
            onClick={(e) => e.stopPropagation()}
          >
            {row.memo ? (
              <span className="memo-preview">{row.memo}</span>
            ) : (
              "메모"
            )}
          </button>
        ),
      },
    ],
  },

  actions: [
    {
      id: "submitted",
      label: "접수\n취소",
      actionType: "submitted",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds, items) => {
        const selectedItems = items.filter((item) =>
          selectedIds.includes(item.adTvAdId),
        );
        const adCampaignMetaIds = [
          ...new Set(
            selectedItems
              .map((item) => item.adCampaignMetaId)
              .filter((id) => id),
          ),
        ];
        const hasUnsubmitted = selectedItems.some(
          (item) => item.isSubmitted !== 1,
        );
        return {
          type: "tv_ad",
          action: "submitted",
          ids: adCampaignMetaIds,
          toggleValue: hasUnsubmitted ? 1 : 0,
        };
      },
    },
    {
      id: "paid",
      label: "결제완료",
      actionType: "paid",
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        const alreadyPaid = items.some(
          (item) => selectedIds.includes(item.adTvAdId) && item.isPaid === 1,
        );
        return !alreadyPaid;
      },
      payloadBuilder: (selectedIds, items) => {
        const selectedItems = items.filter((item) =>
          selectedIds.includes(item.adTvAdId),
        );
        const adPaymentTransactionIds = [
          ...new Set(
            selectedItems
              .map((item) => item.adPaymentTransactionId)
              .filter((id) => id),
          ),
        ];
        return {
          type: "tv_ad",
          action: "paid",
          ids: adPaymentTransactionIds,
          toggleValue: 1,
        };
      },
    },
    {
      id: "complete",
      label: "처리완료\n취소",
      actionType: "complete",
      enabledWhen: (selectedIds) => selectedIds.length > 0,
      payloadBuilder: (selectedIds, items) => {
        const selectedItems = items.filter((item) =>
          selectedIds.includes(item.adTvAdId),
        );
        const hasUncompleted = selectedItems.some(
          (item) => item.isCompleted !== 1,
        );
        return {
          type: "tv_ad",
          action: "completed",
          ids: selectedIds,
          toggleValue: hasUncompleted ? 1 : 0,
        };
      },
    },
    {
      id: "refund",
      label: "환불",
      actionType: "refund",
      requires: "ad.campaign.refund", // 권한 없으면 버튼 숨김 (R-FE-04)
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        return items.some(
          (item) =>
            selectedIds.includes(item.adTvAdId) &&
            (item.isPaid === 1 || item.isPaid === 2) &&
            (item.remainingAmount ?? item.totalAmount ?? 0) > 0,
        );
      },
    },
    {
      id: "delete",
      label: "삭제",
      actionType: "delete",
      enabledWhen: (selectedIds, items) => {
        if (selectedIds.length === 0) return false;
        const selectedCampaigns = items.filter((campaign) =>
          selectedIds.includes(campaign.adCampaignMetaId),
        );
        const hasInvalidCampaign = selectedCampaigns.some((campaign) => {
          const userName = campaign.userName || "";
          return (
            !userName.includes("테스트") &&
            !userName.includes("전유상") &&
            !userName.includes("이령빈") &&
            !userName.includes("서한석") &&
            !userName.includes("null") &&
            !userName.includes("채영호") &&
            !userName.includes("매니저")
          );
        });
        const hasNotTerminatedCampaign = selectedCampaigns.some(
          (campaign) =>
            !(campaign.status === "종료" && campaign.paid === "notComplete"),
        );
        return !(hasInvalidCampaign && hasNotTerminatedCampaign);
      },
      confirm: "선택한 TV 광고 캠페인을 삭제하시겠습니까?",
      payloadBuilder: (selectedIds, items) => ({
        type: "tv_ad",
        ids: selectedIds,
      }),
    },
  ],

  download: {
    type: "xlsx",
    fileName: "TV광고캠페인_신청목록.xlsx",
    sheetName: "TV광고캠페인신청목록",
    transformRow: (row) => {
      const info = row.tvAdProductionInfo || {};
      const typeVal =
        row.type ??
        (Array.isArray(row.mediaPublisher) && row.mediaPublisher.length
          ? row.mediaPublisher[0]
          : null);
      const total = row.totalAmount ?? row.campaignTotalAmount ?? 0;
      let amountVatExcluded = total ? Math.round(Number(total) / 1.1) : 0;

      const regions = row.targetRegions;
      const regionStr = Array.isArray(regions)
        ? regions.join(", ")
        : regions
          ? String(regions)
          : "";
      return {
        매체사: getMediaTypeLabel(typeVal),
        광고명: row.placeName || "",
        "광고비(vat별도)": amountVatExcluded || "",
        시작일: row.startDate || "",
        종료일: row.endDate || "",
        광고길이: getAdDurationLabel(row.adDuration),
        "TV광고 제작 유무": getTvAdProductionLabel(row.tvAdProductionYn),
        "사업장 주소": row.address || "",
        "사업장 연락처": row.phoneNum || "",
        "QR용 URL": row.qrUrl || "",
        홍보문구: info.promo_message || "",
        "마지막씬 강조정보": info.final_scene_highlight || "",
        "AI 성우 성별": row.tvAdProductionYn === 1 ? getVoiceGenderLabel(info.ai_voice_gender) : "-",
        "AI 성우 연령": row.tvAdProductionYn === 1 ? (getVoiceAgeLabel(info.ai_voice_age) || "-") : "-",
        "AI 성우 분위기": row.tvAdProductionYn === 1 ? (info.ai_voice_tone || "-") : "-",
        "AI 성우 멘트": row.tvAdProductionYn === 1 ? (info.ai_voice_script || "-") : "-",
        "첨부파일 링크": row.fileUrl || "",
        "TV광고 지역(요청)": regionStr,
        "추가 요청 사항": row.addedInfo || "",
      };
    },
  },
};
